/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingEntity } from '../models/BookingEntity';
import type { CourseEntity } from '../models/CourseEntity';
import type { CourseGroupEntity } from '../models/CourseGroupEntity';
import type { FormEntity } from '../models/FormEntity';
import type { InstructorEntity } from '../models/InstructorEntity';
import type { MeetingEntity } from '../models/MeetingEntity';
import type { PostCourseGroupDto } from '../models/PostCourseGroupDto';
import type { TagEntity } from '../models/TagEntity';
import type { UpdateCourseGroupDto } from '../models/UpdateCourseGroupDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CourseGroupService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all Course Groups
     * @param instructorId
     * @param archived
     * @returns CourseGroupEntity Course Groups have been returned
     * @throws ApiError
     */
    public courseGroupControllerGetCourseGroupsV1(
        instructorId?: string,
        archived?: boolean,
    ): CancelablePromise<Array<CourseGroupEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/courseGroup',
            query: {
                'instructorId': instructorId,
                'archived': archived,
            },
        });
    }
    /**
     * Create a Course Group
     * @param requestBody
     * @returns CourseGroupEntity Course Group has been created
     * @throws ApiError
     */
    public courseGroupControllerCreateCourseGroupV1(
        requestBody: PostCourseGroupDto,
    ): CancelablePromise<CourseGroupEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/courseGroup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Course has not been found`,
            },
        });
    }
    /**
     * Get a Course Group
     * @param courseGroupId
     * @returns CourseGroupEntity Course Group has been returned
     * @throws ApiError
     */
    public courseGroupControllerGetCourseGroupV1(
        courseGroupId: string,
    ): CancelablePromise<CourseGroupEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/courseGroup/{courseGroupId}',
            path: {
                'courseGroupId': courseGroupId,
            },
            errors: {
                404: `Course Group has not been found`,
            },
        });
    }
    /**
     * Update a Course Group
     * @param courseGroupId
     * @param requestBody
     * @returns CourseGroupEntity The updated Course Group
     * @throws ApiError
     */
    public courseGroupControllerUpdateCourseGroupV1(
        courseGroupId: string,
        requestBody: UpdateCourseGroupDto,
    ): CancelablePromise<CourseGroupEntity> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/courseGroup/{courseGroupId}',
            path: {
                'courseGroupId': courseGroupId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Course Group has not been found`,
            },
        });
    }
    /**
     * Archive a Course Group
     * @param courseGroupId
     * @returns CourseGroupEntity Course Group has been archived
     * @throws ApiError
     */
    public courseGroupControllerArchiveCourseGroupV1(
        courseGroupId: string,
    ): CancelablePromise<CourseGroupEntity> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/courseGroup/{courseGroupId}',
            path: {
                'courseGroupId': courseGroupId,
            },
            errors: {
                404: `Course Group has not been found`,
            },
        });
    }
    /**
     * Get a Course Group's default Instructors
     * @param courseGroupId
     * @returns InstructorEntity Default Instructors of the Course Group have been returned
     * @throws ApiError
     */
    public courseGroupControllerGetCourseGroupDefaultInstructorsV1(
        courseGroupId: string,
    ): CancelablePromise<Array<InstructorEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/courseGroup/{courseGroupId}/instructors',
            path: {
                'courseGroupId': courseGroupId,
            },
        });
    }
    /**
     * Get a Course Group's attendance bookings
     * @param courseGroupId
     * @returns BookingEntity Attendance Bookings of the Course Group have been returned
     * @throws ApiError
     */
    public courseGroupControllerGetCourseGroupAttendanceBookingsV1(
        courseGroupId: string,
    ): CancelablePromise<Array<BookingEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/courseGroup/{courseGroupId}/bookings/attendance',
            path: {
                'courseGroupId': courseGroupId,
            },
        });
    }
    /**
     * Get a Course Groups bookings amount
     * @param courseGroupId
     * @returns number Active Bookings of the Course Group have been returned
     * @throws ApiError
     */
    public courseGroupControllerGetCourseGroupActiveBookingsCountV1(
        courseGroupId: string,
    ): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/courseGroup/{courseGroupId}/bookings/active/count',
            path: {
                'courseGroupId': courseGroupId,
            },
        });
    }
    /**
     * Restore an archived Course Group
     * @param courseGroupId
     * @returns CourseEntity Course Group has been restored
     * @throws ApiError
     */
    public courseGroupControllerRestoreCourseGroupV1(
        courseGroupId: string,
    ): CancelablePromise<CourseEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/courseGroup/{courseGroupId}/restore',
            path: {
                'courseGroupId': courseGroupId,
            },
            errors: {
                404: `Course Group has not been found`,
            },
        });
    }
    /**
     * Get all Meetings of a Course Group
     * @param courseGroupId
     * @returns MeetingEntity Course Group Meetings have been returned
     * @throws ApiError
     */
    public courseGroupControllerGetCourseGroupMeetingsV1(
        courseGroupId: string,
    ): CancelablePromise<Array<MeetingEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/courseGroup/{courseGroupId}/meetings',
            path: {
                'courseGroupId': courseGroupId,
            },
            errors: {
                404: `Course has not been found`,
            },
        });
    }
    /**
     * Get the forms of a Course Group
     * @param courseGroupId
     * @returns FormEntity Forms have been returned
     * @throws ApiError
     */
    public courseGroupControllerGetCourseGroupFormsV1(
        courseGroupId: string,
    ): CancelablePromise<Array<FormEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/courseGroup/{courseGroupId}/forms',
            path: {
                'courseGroupId': courseGroupId,
            },
            errors: {
                404: `Course Group has not been found`,
            },
        });
    }
    /**
     * Get the tags of a course group
     * @param courseGroupId
     * @returns TagEntity Tags have been returned
     * @throws ApiError
     */
    public courseGroupControllerGetCourseGroupTagsV1(
        courseGroupId: string,
    ): CancelablePromise<Array<TagEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/courseGroup/{courseGroupId}/tags',
            path: {
                'courseGroupId': courseGroupId,
            },
            errors: {
                404: `Tags has not been found`,
            },
        });
    }
}
